import React from "react";
import { ExternalLink } from "lucide-react";

export default function GoodsCard({ goods }) {
  return (
    <a
      href={goods.purchase_link}
      target="_blank"
      rel="noopener noreferrer"
      className="flex-shrink-0 min-w-[220px] select-none max-w-[220px] w-[65vw] sm:w-[220px] flex flex-col bg-white dark:bg-gray-800 rounded-lg border border-gray-200 dark:border-gray-700 shadow-sm hover:shadow-md transition-shadow duration-200 overflow-hidden group"
    >
      {/* 상품 이미지 */}
      <div className="relative w-full h-48 bg-gray-100 dark:bg-gray-700 overflow-hidden">
        <img
          src={goods.image_url}
          alt={goods.prod_name}
          className="object-cover group-hover:scale-105 transition-transform duration-200"
          loading="lazy"
        />
      </div>

      {/* 상품 정보 */}
      <div className="flex-1 p-4 flex flex-col">
        <h3 className="text-sm font-medium text-gray-900 dark:text-gray-100 line-clamp-2 mb-2 min-h-[2.5rem]">
          {goods.prod_name}
        </h3>

        <div className="mt-auto flex items-center justify-between">
          <span className="text-sm font-bold text-gray-900 dark:text-gray-100">
            {typeof goods.display_total_price === "number"
              ? `₩${goods.display_total_price.toLocaleString()}`
              : goods.display_total_price}
          </span>
          <ExternalLink
            className="w-4 h-4 text-gray-400 dark:text-gray-500 group-hover:text-gray-600 dark:group-hover:text-gray-300"
            aria-hidden="true"
          />
        </div>
      </div>
    </a>
  );
}
